const CERTIFICATE_DATA = [
    {
        id: "dotnet",
        name: "ASP.NET Core & Web API",
        issuer: "Udemy",
        issuerIcon: "fab fa-udemy",
        issuerColor: "#A435F0",
        category: ".NET / C#",
        categoryColor: "#6C63FF",
        year: "2024",
        skills: ["C#", ".NET Core", "Web API", "Entity Framework"],
        description: "Complete course covering ASP.NET Core MVC, RESTful Web API development, Entity Framework Core, and SQL Server integration.",
        credentialUrl: "https://www.udemy.com/certificate/",
        icon: "fas fa-code",
        iconBg: "linear-gradient(135deg, #6C63FF, #4A44CC)"
    },
    {
        id: "csharp",
        name: "C# Complete Masterclass",
        issuer: "Udemy",
        issuerIcon: "fab fa-udemy",
        issuerColor: "#A435F0",
        category: ".NET / C#",
        categoryColor: "#6C63FF",
        year: "2024",
        skills: ["C#", "OOP", ".NET Framework", "LINQ"],
        description: "In-depth C# programming covering OOP principles, LINQ, async/await, generics, and .NET Framework fundamentals.",
        credentialUrl: "https://www.udemy.com/certificate/",
        icon: "fas fa-hashtag",
        iconBg: "linear-gradient(135deg, #6C63FF, #9B59B6)"
    },
    {
        id: "sqlserver",
        name: "SQL Server — Complete Course",
        issuer: "Udemy",
        issuerIcon: "fab fa-udemy",
        issuerColor: "#A435F0",
        category: "Database",
        categoryColor: "#00C896",
        year: "2024",
        skills: ["SQL Server", "T-SQL", "Stored Procedures", "Query Optimization"],
        description: "Comprehensive SQL Server course covering T-SQL, stored procedures, triggers, indexing, and database optimization techniques.",
        credentialUrl: "https://www.udemy.com/certificate/",
        icon: "fas fa-database",
        iconBg: "linear-gradient(135deg, #00C896, #009970)"
    },
    {
        id: "javascript",
        name: "JavaScript — The Complete Guide",
        issuer: "Udemy",
        issuerIcon: "fab fa-udemy",
        issuerColor: "#A435F0",
        category: "Frontend",
        categoryColor: "#FFD166",
        year: "2023",
        skills: ["JavaScript", "ES6+", "DOM", "Async/Await"],
        description: "Full JavaScript course from basics to advanced — ES6+, DOM manipulation, async programming, and modern JS patterns.",
        credentialUrl: "https://www.udemy.com/certificate/",
        icon: "fab fa-js",
        iconBg: "linear-gradient(135deg, #F7DF1E, #CC9900)",
        iconColor: "#1A1A2E"
    },
    {
        id: "bootstrap",
        name: "Bootstrap 5 — Responsive Design",
        issuer: "Udemy",
        issuerIcon: "fab fa-udemy",
        issuerColor: "#A435F0",
        category: "Frontend",
        categoryColor: "#FFD166",
        year: "2023",
        skills: ["Bootstrap 5", "CSS3", "Responsive Design", "Flexbox"],
        description: "Bootstrap 5 complete course covering responsive grid, components, utilities, and building mobile-first web interfaces.",
        credentialUrl: "https://www.udemy.com/certificate/",
        icon: "fab fa-bootstrap",
        iconBg: "linear-gradient(135deg, #7952B3, #5A3E8E)"
    },
    {
        id: "aws",
        name: "AWS Cloud Practitioner",
        issuer: "Udemy",
        issuerIcon: "fab fa-udemy",
        issuerColor: "#A435F0",
        category: "Cloud",
        categoryColor: "#FF6B6B",
        year: "2024",
        skills: ["AWS EC2", "S3", "RDS", "IAM", "Lambda"],
        description: "AWS Cloud fundamentals covering core services — EC2, S3, RDS, Lambda, IAM, and cloud architecture best practices.",
        credentialUrl: "https://www.udemy.com/certificate/",
        icon: "fab fa-aws",
        iconBg: "linear-gradient(135deg, #FF9900, #CC7700)"
    },
    {
        id: "react",
        name: "React — The Complete Guide",
        issuer: "Udemy",
        issuerIcon: "fab fa-udemy",
        issuerColor: "#A435F0",
        category: "Frontend",
        categoryColor: "#FFD166",
        year: "2023",
        skills: ["React.js", "Hooks", "Redux", "TypeScript"],
        description: "Complete React course covering components, hooks, state management with Redux, React Router, and TypeScript integration.",
        credentialUrl: "https://www.udemy.com/certificate/",
        icon: "fab fa-react",
        iconBg: "linear-gradient(135deg, #61DAFB, #21A1C4)",
        iconColor: "#1A1A2E"
    },
    {
        id: "git",
        name: "Git & GitHub — Complete Course",
        issuer: "Udemy",
        issuerIcon: "fab fa-udemy",
        issuerColor: "#A435F0",
        category: "Tools",
        categoryColor: "#a89cff",
        year: "2023",
        skills: ["Git", "GitHub", "Branching", "CI/CD basics"],
        description: "Git version control from basics to advanced — branching strategies, merging, rebasing, GitHub workflows, and team collaboration.",
        credentialUrl: "https://www.udemy.com/certificate/",
        icon: "fab fa-git-alt",
        iconBg: "linear-gradient(135deg, #F05032, #C0392B)"
    }
];

export default CERTIFICATE_DATA;
